import axios from "axios";
import SideNavbar from "../../components/common/SideNavbar";
import TopNavbar from "../../components/common/TopNavbar";
import { useEffect, useState, useRef } from "react";
import { Button, Spinner, Modal } from "react-bootstrap";
import { toast, ToastContainer } from "react-toastify";
import DataTable from "react-data-table-component";
import { tableCustomStyles } from "../../utils/TableCustomStyles";

function CargoNameMaster() {
  const addform = useRef(null);
  const [menuDrawerShow, setMenuDrawerShow] = useState(true);
  const [data, setData] = useState([]);
  const [dataPending, setDataPending] = useState(true);
  const [currentUserRolePermissionData, setCurrentUserRolePermissionData] =
    useState([]);
  const [dataFromTopNavBar, setDataFromTopNavBar] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const user_role = sessionStorage["userrole"];

  const [canvasFullScreen, setCanvasFullScreen] = useState(false);
  const [showNameError, setShowNameError] = useState(false);
  const [showCodeError, setShowCodeError] = useState(false);
  const [showUpdateNameError, setShowUpdateNameError] = useState(false);
  const [showUpdateCodeError, setShowUpdateCodeError] = useState(false);
  const [updateId, setUpdateId] = useState("");

  const [name, setName] = useState("");
  const [cargoType, setCargoType] = useState("NON_HAZARDOUS");
  const [status, setStatus] = useState("ACTIVE");

  const [updateName, setUpdateName] = useState("");
  const [updateCargoType, setUpdateCargoType] = useState("NON_HAZARDOUS");
  const [updateStatus, setUpdateStatus] = useState("ACTIVE");
  const [showAddCanvas, setShowAddCanvas] = useState(false);
  const [showUpdateCanvas, setShowUpdateCanvas] = useState(false);

  const [showAddLoader, setShowAddLoader] = useState(false);
  const [showUpdateLoader, setShowUpdateLoader] = useState(false);
  const [showDeleteLoader, setShowDeleteLoader] = useState(false);
  const [deleteRecordId, setDeleteRecordId] = useState(null);
  const [addButtonDisabled, setAddButtonDisabled] = useState(true);
  const [updateButtonDisabled, setUpdateButtonDisabled] = useState(true);

  const [isAddValidationVisible, setIsAddValidationVisible] = useState(false);
  const [isUpdateValidationVisible, setIsUpdateValidationVisible] =
    useState(false);

  const buildAddErrors = () => {
    const errors = [];
    if (!name) errors.push("Cargo Name is required");
    return errors;
  };

  const buildUpdateErrors = () => {
    const errors = [];
    if (!updateName) errors.push("Cargo Name is required");
    return errors;
  };

  const user_id = sessionStorage["id"];
  const [loggedInUser, setLoggedInUser] = useState(null);

  const getLoggenInUser = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/user/user/" + user_id,
      );
      if (response) {
        setLoggedInUser(response.data);
      }
    } catch (err) {
      toast.error("Error in fetching user data! Try again.");
    }
  };

  const getCargo = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL + "/master/cargo/",
      );
      setTimeout(() => {
        if (response) {
          setData(response.data);
          setDataPending(false);
        }
      }, 500);
    } catch (err) {
      toast.error("Error in fetching cargo data! Try again.");
    }
  };

  const getCurrentUserRolePermission = async (roles) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_API_URL +
          "/user/role/getuserrolepermission?roles=" +
          roles,
      );

      const role_permissions_array = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < response?.data[i]?.permissions_array.length; j++) {
          if (
            !role_permissions_array.includes(
              response?.data[i]?.permissions_array?.[j],
            )
          ) {
            role_permissions_array.push(
              response?.data[i]?.permissions_array?.[j],
            );
          }
        }
      }

      if (role_permissions_array) {
        setCurrentUserRolePermissionData(role_permissions_array);
      }
    } catch (err) {
      toast.error("Error in fetching user role data! Try again.");
    }
  };

  const handleDeleteModalClose = () => {
    setShowDeleteModal(false);
  };

  const handleDeleteModalOpen = (row) => {
    setShowDeleteModal(true);
    setDeleteRecordId(row.id);
  };

  useEffect(() => {
    getCargo();
    getLoggenInUser();
  }, []);

  useEffect(() => {
    getCurrentUserRolePermission(user_role);
  }, [user_role]);

  const get_user = (userjson) => {
    console.log("userjson", userjson);
    if (!userjson == null) {
      const user_data = JSON.parse(userjson);
      return user_data?.name;
    } else {
      return "None";
    }
  };

  const columns = [
    {
      name: "Cargo Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "Cargo Type",
      selector: (row) => row.cargo_type,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Created By",
      selector: (row) => get_user(row.created_by),
      sortable: true,
    },
    {
      name: "Created On",
      selector: (row) => row.created_on.slice(0, 10),
      sortable: true,
    },
    {
      name: "Action",
      right: true,
      selector: (row) => (
        <div>
          {currentUserRolePermissionData?.includes("master:cargo:update") ? (
            <Button
              className="btn btn-sm btn-inox-green border-0"
              title="Update"
              data-bs-toggle="offcanvas"
              data-bs-target="#updateSection"
              onClick={() => handleSetUpdateData(row)}
            >
              <i className="fa fa-edit"></i>
            </Button>
          ) : (
            ""
          )}

          {currentUserRolePermissionData?.includes("master:cargo:delete") ? (
            <Button
              className="btn btn-sm bg-danger border-0 mx-2"
              title="Delete"
              onClick={() => handleDeleteModalOpen(row)}
            >
              <i className="fa fa-trash"></i>
            </Button>
          ) : (
            ""
          )}
        </div>
      ),
    },
  ];

  const handleSetUpdateData = (row) => {
    setUpdateId(row.id);
    setUpdateName(row.name);
    setUpdateCargoType(row.cargo_type);
    setUpdateStatus(row.status);
  };

  const addPackage = async (e) => {
    e.preventDefault();
    setShowAddLoader(true);

    const data = {
      name: addform.current.name.value,
      cargo_type: addform.current.cargo_type.value,
      status: addform.current.status.value,
      created_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.post(
      process.env.REACT_APP_BACKEND_API_URL + "/master/cargo/",
      data,
      {
        headers: { "content-type": "application/json" },
      },
    );

    if (response.status === 201) {
      toast.success("Cargo Created Successfully");
    }

    setName("");
    setCargoType("");
    setStatus("ACTIVE");
    getCargo();
    setShowAddCanvas(false);
    setShowAddLoader(false);
  };

  const updatePackage = async (e) => {
    e.preventDefault();
    setShowUpdateLoader(true);
    const id = updateId;

    const data = {
      name: updateName,
      cargo_type: updateCargoType,
      status: updateStatus,
      modified_by: JSON.stringify({"id": loggedInUser?.id, "username": loggedInUser?.username, "name": loggedInUser?.name, "email": loggedInUser?.email, "mobile": loggedInUser?.mobile, "user_type": loggedInUser?.user_type}),
    };

    const response = await axios.put(
      process.env.REACT_APP_BACKEND_API_URL + "/master/cargo/" + id + "/",
      data,
      {
        headers: { "content-type": "application/json" },
      },
    );

    if (response.status === 200) {
      toast.success("Cargo Updated Successfully");
    }

    getCargo();
    setShowUpdateCanvas(false);
    setShowUpdateLoader(false);
  };

  const deletePackage = async (e) => {
    e.preventDefault();
    setShowDeleteLoader(true);
    const id = deleteRecordId;

    const response = await axios.delete(
      process.env.REACT_APP_BACKEND_API_URL + "/master/cargo/" + id + "/",
      data,
      {
        headers: { "content-type": "application/json" },
      },
    );

    console.log("response.status", response.status);
    if (response.status === 204) {
      toast.success("Cargo Deleted Successfully");
    }

    getCargo();
    setShowDeleteLoader(false);
    setShowDeleteModal(false);
  };

  const validateCargoName = (value) => {
    if (value == "") {
      setShowNameError(true);
      setAddButtonDisabled(true);
    } else {
      setShowNameError(false);
      setAddButtonDisabled(false);
    }
  };

  const validateUpdateCargoName = (value) => {
    if (value == "") {
      setShowUpdateNameError(true);
      setUpdateButtonDisabled(true);
    } else {
      setShowUpdateNameError(false);
      setUpdateButtonDisabled(false);
    }
  };

  function handleDataFromTopNavBar(permissiondata) {
    setDataFromTopNavBar(permissiondata);
  }

  return (
    <div className="page-content-bg">
      <ToastContainer></ToastContainer>
      <TopNavbar
        sidebarCollapsed={menuDrawerShow}
        topNavbarStatic={true}
        sendDataToParent={handleDataFromTopNavBar}
      />
      <SideNavbar
        sidebarCollapsed={menuDrawerShow}
        activeMenu="Master"
        activeSubMenu="CargoNameMaster"
        activeSubMenuLevel1=""
        permissionFromTopNavbar={dataFromTopNavBar}
      />

      <div
        className={
          menuDrawerShow
            ? "row main-content-collapsed text-left py-0"
            : "row main-content text-left py-0"
        }
      >
        <div className="col-12 page-header">
          <div className="row">
            <div className="col-6 py-1">
              <Button
                className="btn btn-sm btn-inox-green border-0 mx-2"
                onClick={() => setMenuDrawerShow(!menuDrawerShow)}
              >
                {menuDrawerShow ? (
                  <span>
                    <i className="fa fa-chevron-left mx-1"></i>
                  </span>
                ) : (
                  <span>
                    <i className="fa fa-chevron-right mx-1"></i>
                  </span>
                )}
              </Button>
              <span className="page-header-text">Cargo Master</span>
            </div>

            <div className="col-6 py-1" style={{ paddingRight: 30 }}>
              {currentUserRolePermissionData?.includes(
                "master:packagetype:add",
              ) ? (
                <Button
                  className="btn btn-sm btn-inox-green border-0  px-3 float-right"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#addSection"
                >
                  <i
                    className="fa fa-plus fa-lg text-right"
                    style={{ paddingRight: 10 }}
                  ></i>
                  <span className="fw-bold">Add Cargo</span>
                </Button>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>

        <div
          className="col-12 text-left"
          style={{
            marginTop: -5,
            paddingLeft: 20,
            paddingRight: 30,
            zIndex: 100,
          }}
        >
          <DataTable
            columns={columns}
            data={data}
            progressPending={dataPending}
            progressComponent={
              <Spinner
                className="mx-5 text-inox-green table-spinner"
                as="span"
                animation="border"
                size="lg"
                role="status"
                aria-hidden="true"
              />
            }
            noDataComponent={
              <p className="text-center table-no-data">No Data Found</p>
            }
            pagination
            highlightOnHover
            fixedHeader
            customStyles={tableCustomStyles}
            dense
          />
        </div>
      </div>

      <Modal
        size="sm"
        show={showDeleteModal}
        onHide={handleDeleteModalClose}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to delete this record?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleDeleteModalClose}>
            Close
          </Button>
          <Button variant="danger" onClick={(e) => deletePackage(e)}>
            {showDeleteLoader ? (
              <Spinner
                className="mx-3 text-white"
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "Delete"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ------------------------ Update Section ------------------- */}
      <div
        class={
          canvasFullScreen && showUpdateCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showUpdateCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        id="updateSection"
        data-bs-scroll="true"
        tabindex="-1"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Upload Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                class="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => [setShowUpdateCanvas(false)]}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowUpdateCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div class="offcanvas-body">
          <form onSubmit={(e) => updatePackage(e)}>
            <div className="row">
              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="name">
                  Cargo Name: <i className="text-danger">*</i>
                  <span className="text-danger">
                    {showUpdateNameError ? " Package Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="name"
                  name="name"
                  placeholder="Enter Package Name"
                  value={updateName}
                  onChange={(e) => setUpdateName(e.target.value)}
                  onBlur={(e) => validateUpdateCargoName(e.target.value)}
                />
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="cargo_type">Cargo Type: </label>
                <select
                  className="form-select form-select-sm"
                  name="cargo_type"
                  onChange={(e) => setUpdateCargoType(e.target.value)}
                >
                  <option
                    value="HAZARDOUS"
                    selected={updateCargoType == "HAZARDOUS" ? true : false}
                  >
                    HAZARDOUS
                  </option>
                  <option
                    value="NON_HAZARDOUS"
                    selected={updateCargoType == "NON_HAZARDOUS" ? true : false}
                  >
                    NON HAZARDOUS
                  </option>
                </select>
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="status">Status: </label>
                <select
                  className="form-select form-select-sm"
                  name="status"
                  onChange={(e) => setUpdateStatus(e.target.value)}
                >
                  <option
                    value="ACTIVE"
                    selected={updateStatus == "ACTIVE" ? true : false}
                  >
                    ACTIVE
                  </option>
                  <option
                    value="INACTIVE"
                    selected={updateStatus == "INACTIVE" ? true : false}
                  >
                    INACTIVE
                  </option>
                </select>
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <Button
                  className="btn btn-inox-green border-0 canvas-button btn-sm mt-4"
                  onClick={(e) => updatePackage(e)}
                  disabled={updateButtonDisabled}
                >
                  <i className="fa fa-edit"></i>
                  <span className="mx-2">
                    {showUpdateLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Update"
                    )}
                  </span>
                </Button>
                {updateButtonDisabled && (
                  <div className="error-tooltip-wrapper ms-2 mt-4">
                    <Button
                      style={{ backgroundColor: "#C21E22" }}
                      onClick={() =>
                        setIsUpdateValidationVisible(!isUpdateValidationVisible)
                      }
                      onMouseLeave={() => setIsUpdateValidationVisible(false)}
                    >
                      !
                    </Button>

                    {isUpdateValidationVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-3">
                          {buildUpdateErrors().map((err, i) => (
                            <li key={i}>{err}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Update Section ------------------- */}

      {/* ------------------------ Add Section ------------------- */}
      <div
        class={
          canvasFullScreen && showAddCanvas
            ? "offcanvas offcanvas-bottom h-100 show"
            : !canvasFullScreen && showAddCanvas
              ? "offcanvas offcanvas-bottom h-60 show"
              : "offcanvas offcanvas-bottom h-60"
        }
        data-bs-scroll="true"
        tabindex="-1"
        id="addSection"
        aria-labelledby="offcanvasBottomLabel"
      >
        <div class="offcanvas-header w-100">
          <div className="row w-100">
            <div className="col-6">
              <h4 id="offcanvasBottomLabel" className="float-left">
                Add New Record
              </h4>
            </div>
            <div className="col-6">
              <button
                type="button"
                class="btn btn-danger btn-sm float-right"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
                title="Close"
                onClick={() => [setShowAddCanvas(false)]}
              >
                <i className="fa fa-times text-white"></i>
              </button>

              {canvasFullScreen ? (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Half Screen"
                  onClick={() => [
                    setCanvasFullScreen(false),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-minimize text-white"></i>
                </button>
              ) : (
                <button
                  type="button"
                  class="btn btn-inox-green btn-sm mx-2 float-right"
                  title="Full Screen"
                  onClick={() => [
                    setCanvasFullScreen(true),
                    setShowAddCanvas(true),
                  ]}
                >
                  <i className="fa fa-window-maximize text-white"></i>
                </button>
              )}
            </div>
          </div>
        </div>
        <div class="offcanvas-body">
          <form ref={addform} onSubmit={(e) => addPackage(e)}>
            <div className="row">
              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="name">
                  Cargo Name: <i className="text-danger">*</i>
                  <span className="text-danger">
                    {showNameError ? " Package Name required" : ""}
                  </span>
                </label>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  id="name"
                  name="name"
                  placeholder="Enter Package Name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  onBlur={(e) => validateCargoName(e.target.value)}
                />
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="cargo_type">Cargo Type: </label>
                <select
                  className="form-select form-select-sm"
                  name="cargo_type"
                  onChange={(e) => setCargoType(e.target.value)}
                >
                  <option value="HAZARDOUS">HAZARDOUS</option>
                  <option value="NON_HAZARDOUS" selected>
                    NON HAZARDOUS
                  </option>
                </select>
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <label for="status">Status: </label>
                <select
                  className="form-select form-select-sm"
                  name="status"
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="ACTIVE" selected>
                    ACTIVE
                  </option>
                  <option value="INACTIVE">INACTIVE</option>
                </select>
              </div>

              <div
                class={`form-group ${canvasFullScreen ? "col-md-3" : "col-md-3"} text-left mb-4`}
              >
                <Button
                  className="btn btn-inox-green border-0 canvas-button btn-sm mt-4"
                  onClick={(e) => addPackage(e)}
                  disabled={addButtonDisabled}
                >
                  <i className="fa fa-plus"></i>
                  <span className="mx-2">
                    {showAddLoader ? (
                      <Spinner
                        className="mx-3 text-white"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "Add"
                    )}
                  </span>
                </Button>
                {addButtonDisabled && (
                  <div className="error-tooltip-wrapper ms-2 mt-4">
                    <Button
                      style={{ backgroundColor: "#C21E22" }}
                      onClick={() =>
                        setIsAddValidationVisible(!isAddValidationVisible)
                      }
                      onMouseLeave={() => setIsAddValidationVisible(false)}
                    >
                      !
                    </Button>

                    {isAddValidationVisible && (
                      <div className="validation-error-tooltip">
                        <ul className="mb-0 px-3">
                          {buildAddErrors().map((err, i) => (
                            <li key={i}>{err}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>
      {/* ------------------------ Add Section ------------------- */}
    </div>
  );
}

export default CargoNameMaster;
